/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React, { useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import SDCreateIssueModal from './SDCreateIssueModal';

const SDPageHeader = ({ title, me, projects, selectedProjectId, onProjectChanged, showCreateIssue = false }) => {
    const [showCreateIssueModal, setShowCreateIssueModal] = useState(false);

    const openCreateIssueModal = () => setShowCreateIssueModal(true);
    const closeCreateIssueModal = () => setShowCreateIssueModal(false);


    const handleProjectChanged = async (e) => {
        const newValue = e.target.value;
        onProjectChanged(newValue);
    };

    return (
        <Row className="gx-0 kanban-header rounded-2 px-card py-2 mt-2 mb-3">
            <Col className="d-flex align-items-center">
                <h5 className="mb-0">{title}</h5>

            </Col>
            <Col xs="auto" as={Flex} alignItems="center">

                {projects && projects.length > 0 ?
                    <Form.Select aria-label="Default select example" className="mr-6" size="sm" value={selectedProjectId} onChange={handleProjectChanged}>
                        {projects.map((project) => (
                            <option key={project.id} value={project.id}>
                                {project.name}
                            </option>
                        ))}

                    </Form.Select> : <></>}
                <div style={{
                    borderLeft: '1px solid rgba(0,0,0,0.2)',
                    height: '100%',
                    margin: '0 10px'
                }} />

            </Col>
            <Col xs="auto" as={Flex} alignItems="center">
                {/* {me != null ? <i>{me.email}&nbsp;&nbsp;</i> : <></>} */}
                {showCreateIssue ?
                    <IconButton icon="plus" className="m-1" transform="shrink-3" size="sm" onClick={openCreateIssueModal}>
                        Create Issue
                    </IconButton> : <></>}
            </Col>

            <SDCreateIssueModal show={showCreateIssueModal} handleClose={closeCreateIssueModal} projects={projects} selectedProjectId={selectedProjectId}></SDCreateIssueModal>
        </Row>
    );
};

export default SDPageHeader;
